import { render, staticRenderFns } from "./layout-footer.vue?vue&type=template&id=11983004&"
import script from "./layout-footer.vue?vue&type=script&lang=js&"
export * from "./layout-footer.vue?vue&type=script&lang=js&"
import style0 from "./layout-footer.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "layout-footer.vue"
export default component.exports